import { Map } from 'immutable';
import { lruMemoize } from 'reselect';

import {
    getResourceError,
    isResourceFailed,
    isResourceLoading,
} from './common';

const isStaticsLoading = lruMemoize(isResourceLoading);
const isStaticsFailed = lruMemoize(isResourceFailed);
const getStatics = lruMemoize((data) => data.get('data', new Map()));
const getStaticsError = lruMemoize(getResourceError);

export {
    isStaticsFailed,
    isStaticsLoading,
    getStatics,
    getStaticsError,
};
